/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    IncidentStatistic,
    ResponseReason,
} from './';

/**
 * Response with incidents statistic
 * @export
 * @interface ResponseStatisticBody
 */
export interface ResponseStatisticBody {
    /**
     * @type {IncidentStatistic}
     * @memberof ResponseStatisticBody
     */
    data?: IncidentStatistic;
    /**
     * @type {string}
     * @memberof ResponseStatisticBody
     */
    message?: string;
    /**
     * @type {ResponseReason}
     * @memberof ResponseStatisticBody
     */
    reason?: ResponseReason;
}
